import MainComponent from "components/Main";

import ButtonIcon from "components/ButtonIcon";
import Table from "components/Table";

import './index.less';
import './themes/default.less';

export default class ReportSalary extends MainComponent {

    constructor(props) {
        super(props);

        this.tableMap = {
            clinicId: {
                label: "login.clinic",
                style: "hand",
                type: "clinic",
            },
            doctor: {
                label: "client.doctor",
                style: "hand",
            },
            doctorsPosition: {
                label: "client.post",
                style: "hand",
            },
            invoiceAmount: {
                label: "Выставлено счетов",
                type: "sum",
                style: "hand",
                callback: this.invoiceAmountCell.bind(this),
            },
            paid: {
                label: "Оплачено",
                type: "sum",
                style: "hand",
            },
            materials: {
                label: "Материалы",
                type: "sum",
                style: "hand",
            },
            rentgen: {
                label: "Рентген",
                type: "sum",
                style: "hand",
            },
            toPay: {
                label: "К расчету",
                type: "sum",
                style: "hand",
            },
        };

        this.tableMapDoctor = {
            patient: {
                label: "main.patient",
                style: "hand",
                callback: this.cellPatient.bind(this),
                onClick: this.openClientOfSalary.bind(this)
            },
            invoiceId: {
                label: "client.number",
                style: "hand comment",
                onClick: this.changeSalaryView.bind(this, "invoice")
            },
            invoiceDate: {
                label: "client.date",
                callback: this.cellDate.bind(this),
            },
            invoiceAmount: {
                label: "Выставлено по счету",
                style: "hand",
                callback: this.cellSum.bind(this),
                onClick: this.changeSalaryView.bind(this, "invoice")
            },
            lastPayDate: {
                label: "Дата оплаты",
                callback: this.cellDate.bind(this),
            },
            paid: {
                label: "Оплачено",
                callback: this.cellPaid.bind(this),
                onClick: this.changeSalaryView.bind(this, "invoice")
            },
            materials: {
                label: "Материалы",
                callback: this.cellSum.bind(this),
            },
            rentgen: {
                label: "Рентген",
                callback: this.cellSum.bind(this),
            },
            toplam: {
                label: "К расчету",
                callback: this.toplamCell.bind(this),
                style: "p1SemiBold",
            },

        };

        this.tableMapInvoice = {
            altCode: {
                label: "main.code",
            },
            title: {
                label: "price.positionName",
            },
            count: {
                label: "main.quantity",
            },
            invoiceTotalSum: {
                label: "Выставлено по счету",
                type: "sum",
            },
            paid: {
                label: "Оплачено",
                type: "sum",
            },

        };

        this.state = {
            ...this.state,
            itemsSalary: [],
            itemsSalaryDetails: [],
            securedInvoiceItems: [],
            sort: "doctor",
            tableSalaryMode: "global",
            currentClinic: 1,
            selectedDoctor: -1,
            itemsSalaryToplam: {},
            itemsSalaryDetailsToplam: {},
            currentSecondText: `${this.tr("report.formed")} ${this._helper.date.toStr(new Date(), 'DD.MM.YYYY HH:mm')}`
        };
    }

    componentDidMount() {
        const { doctorId, clinic, invoiceId, doctor } = this.props.info.urlProps;
        if (!doctorId && !invoiceId) {
            this.getSalary();
        } else if (doctorId) {
            this.changeSalaryView("doctor", { doctorId, clinic: decodeURIComponent(clinic), invoiceId, doctor: decodeURIComponent(doctor) });
        } else {
            this.changeSalaryView("invoice", { doctorId, clinic: decodeURIComponent(clinic), invoiceId, doctor: decodeURIComponent(doctor) });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedStartDate !== prevProps.selectedStartDate ||
            this.props.selectedEndDate !== prevProps.selectedEndDate) {
            this.setGlobalPageDidUpdate();
        }
    }

    async setGlobalPageDidUpdate() {
        await this.getSalary();
        this.setGlobalPage();
    }

    async changeSalaryView(source, info) {
        const { doctorId, clinic, invoiceId, doctor } = info;
        const { setPageProps } = this.props.events;
        const { itemsSalary } = this.state;
        const props = { doctorId, clinic, invoiceId, doctor };
        if (source === "doctor") {
            await this.getSalaryDetails(info);
            const tableSalaryMode = "details";
            const currentSecondText = `${clinic} ${doctor}`;
            const selectedDoctor = itemsSalary.findIndex(it => it.doctorId === doctorId && it.clinic === clinic);
            this.setState({ tableSalaryMode, currentSecondText, selectedDoctor });
        } else {
            await this.getInvoiceDetails(invoiceId);
            this.changeState("tableSalaryMode", "invoice");
        }
        setPageProps(props);
    }

    invoiceAmountCell(value, map, { returnsSelectedPeriod, invoiceAmount }) {
        return this._helper.number.toSum(invoiceAmount - returnsSelectedPeriod);
    }

    toplamCell(value, map, { paid, materials, status }) {
        const props = {};
        if (status === "CANCELLED") {
            props.className = "comment";
            props["data-tooltip"] = "Счет отменен";
        }

        return (<div {...props}>
            {this._helper.number.toSum(paid - materials)}
        </div>);
    }

    invoicePaidSumCell(value, map, { discount, price }) {
        const { paidSumInvoice, totalSumInvoice } = this.state;
        if (paidSumInvoice === totalSumInvoice) {
            if (discount)
                return this._helper.number.toSum(this._helper.number.percentMinus(price, discount));
            return this._helper.number.toSum(price);
        } else if (paidSumInvoice) {
            const disc = this._helper.number.percentMinus(price, discount);
            const paid = (disc * paidSumInvoice) / totalSumInvoice;
            return this._helper.number.toSum(paid);
        }

        return this._helper.number.toSum(0);
    }

    cellPaid(value, map, info) {
        const { status } = info;
        const props = {};
        if (value < 0) {
            props.className = "comment";
            props["data-tooltip"] = "Отмена счета за прошлый период";
        } else if (status === "CANCELLED") {
            props.className = "comment";
            props["data-tooltip"] = "Счет отменен";
        } else {
            props.className = "hand";
            props.onClick = this.changeSalaryView.bind(this, "invoice", info);
        }
        return (<div {...props}>
            {this._helper.number.toSum(value)}
        </div>);
    }

    cellSum(value, map, { status }) {
        const props = {};
        if (status === "CANCELLED") {
            props.className = "comment";
            props["data-tooltip"] = "Счет отменен";
        }

        return (<div {...props}>
            {this._helper.number.toSum(value)}
        </div>);
    }

    cellPatient(value, map, { status }) {
        const props = {};
        if (status === "CANCELLED") {
            props.className = "comment";
            props["data-tooltip"] = "Счет отменен";
        }

        return (<div {...props}>
            {value}
        </div>);
    }

    cellDate(value, map, { status }) {
        const props = {};
        if (!value)
            return "";

        if (status === "CANCELLED") {
            props.className = "comment";
            props["data-tooltip"] = "Счет отменен";
        }

        return (<div {...props}>
            {this._helper.date.toDateStr(value)}
        </div>);
    }

    async getSalary() {
        const { getFormatDate } = this.props.events;
        const { dateFrom, dateTo } = getFormatDate();

        const clinics = this._helper.getClinics().map(it => it.id);
        const info = {
            clinicIdList: clinics,
            dateFrom,
            dateTo
        };

        this._helper.showLoading();
        const resp = await this._request.report.getOneRow("salary-selected-clinics", info);
        this._helper.hideLoading();
        const itemsSalary = resp?.data || [];

        itemsSalary.sort((a, b) => (a.doctor < b.doctor) ? -1 : (a.doctor > b.doctor) ? 1 : 0);

        this.setState({ itemsSalary });
        this.props.events.setClinics(itemsSalary);
    }

    async getSalaryDetails(invoice) {
        const { doctorId, /*clinic, */ clinicId, currentClinic, rentgen, materials, paid, invoiceAmount, toPay, returnsSelectedPeriod } = invoice;
        const { getFormatDate } = this.props.events;
        const { dateFrom, dateTo } = getFormatDate();
        const info = {
            doctorId,
            clinicId,
            dateFrom,
            dateTo
        };

        this._helper.showLoading();
        const resp = await this._request.report.getOneRow("salary-with-returns-detailed", info);
        this._helper.hideLoading();
        const ids = resp?.data || [];

        const itemsSalaryDetails = ids/*.filter(it => !(it.status === "CANCELLED" && it.paid === 0))*/
            .filter(it => it.clinicId === currentClinic).sort((a, b) => (a.patient < b.patient) ? -1 : (a.patient > b.patient) ? 1 : 0);

        if (itemsSalaryDetails.length > 0) {
            this.state.itemsSalaryDetailsToplam = {
                patient: this.tr("report.total"),
                invoiceAmount: invoiceAmount - returnsSelectedPeriod,
                paid,
                materials,
                rentgen,
                toplam: toPay,
            };
        } else {
            this.state.itemsSalaryDetailsToplam = {};
        }

        this.setState({ itemsSalaryDetails });
    }

    getInvoiceTotalSum(price, discount) {
        if (discount)
            return this._helper.number.percentMinus(price, discount);
        return price;
    }

    getInvoicePaidSum(price, discount, paidSumInvoice, totalSumInvoice) {
        if (paidSumInvoice === totalSumInvoice) {
            if (discount)
                return this._helper.number.percentMinus(price, discount);
            return price;
        } else if (paidSumInvoice) {
            const disc = this._helper.number.percentMinus(price, discount);
            const paid = (disc * paidSumInvoice) / totalSumInvoice;
            return paid;
        }

        return 0;
    }

    /*
    invoicePaidSumCell(value, map, { discount, price }) {
        const { paidSumInvoice, totalSumInvoice } = this.state;
        if (paidSumInvoice === totalSumInvoice) {
            if (discount)
                return this._helper.number.toSum(this._helper.number.percentMinus(price, discount));
            return this._helper.number.toSum(price);
        } else if (paidSumInvoice) {
            const disc = this._helper.number.percentMinus(price, discount);
            const paid = (disc * paidSumInvoice) / totalSumInvoice;
            return this._helper.number.toSum(paid);
        }

        return this._helper.number.toSum(0);
    }
    
    */

    async getInvoiceDetails(invoiceId) {
        this._helper.showLoading();
        const resp = await this._request.invoices.getDetails(invoiceId);
        this._helper.hideLoading();
        const invoice = resp?.data || {};
        let securedInvoiceItems = invoice.securedInvoiceItems || [];
        const paidSumInvoice = invoice.paidSum || 0;
        const totalSumInvoice = invoice.totalSum || 0;

        securedInvoiceItems = securedInvoiceItems.map(it => {
            const { price, discount, count } = it;
            it.invoiceTotalSum = this.getInvoiceTotalSum(price, discount) * count;
            it.paid = this.getInvoicePaidSum(price, discount, paidSumInvoice, totalSumInvoice) * count;
            return it;
        });

        if (securedInvoiceItems.length > 0) {
            this.state.itemsInvoiceToplam = {
                altCode: this.tr("report.total"),
                title: "",
                count: "",
                invoiceTotalSum: securedInvoiceItems.reduce((acc, it) => acc += it.invoiceTotalSum, 0),
                paid: securedInvoiceItems.reduce((acc, it) => acc += it.paid, 0),
            };
        } else {
            this.state.itemsInvoiceToplam = {};
        }

        this.setState({ securedInvoiceItems });
    }

    onOpenDetails(link) {
        this.loadReport(link);
    }

    openClient(id, props) {
        this._helper.openClient(id, props);
    }

    openClientOfSalary({ clientId }) {
        this.openClient(clientId, { tab: "invoices" });
    }

    handleScrollX(scrollLeft) {
        if (scrollLeft === 0)
            this.changeState("isLeftmost", true);
        else
            this.changeState("isLeftmost", false);
    }

    setGlobalPage() {
        const { setPageProps } = this.props.events;
        const currentSecondText = `${this.tr("report.formed")} ${this._helper.date.toStr(new Date(), 'DD.MM.YYYY HH:mm')}`;
        const tableSalaryMode = "global";
        this.setState({ tableSalaryMode, currentSecondText }, this.checkScrollToItem.bind(this));
        setPageProps({ typeN: "salary" });
    }

    onReturnBackSalary() {
        let { tableSalaryMode, itemsSalary } = this.state;
        const { setPageProps } = this.props.events;

        if (itemsSalary?.length < 1) {
            this.getSalary();
        }

        if (tableSalaryMode === "details" || itemsSalary?.length < 1) {
            this.setGlobalPage();
        } else if (tableSalaryMode === "invoice") {
            this.changeState("tableSalaryMode", "details");
            setPageProps({ typeN: "salary" });
        }
    }

    checkScrollToItem() {
        const { selectedDoctor } = this.state;
        if (selectedDoctor === -1)
            return;

        const item = this.refTableSalary?.domNode.querySelector(".row" + selectedDoctor);
        if (item)
            this.refTableSalary?.domNode.scrollTo({ top: item.offsetTop - 150 });

    }

    onSortChange(sort) {
        this.state.sort = sort;
        this.refresh();
    }

    getHeaderText() {
        const { selectedStartDate, selectedEndDate } = this.props;
        const sdate = this._helper.date.toStr(selectedStartDate, 'DD MMMM YYYY');
        const sdateshort = this._helper.date.toStr(selectedStartDate, 'DD MMMM');
        if (selectedEndDate !== null) {
            const edate = this._helper.date.toStr(selectedEndDate, 'DD MMMM YYYY');
            return `${this.tr("report.salaryReport")} ${sdateshort} - ${edate}`;
        }

        return `${this.tr("report.salaryReport")} ${sdate}`;
    }

    itemsSalaryFilter(itemsSalary, clinics, currentClinic) {
        const clinic = clinics.find(it => it.id === currentClinic);
        const res = itemsSalary.filter(it => it.clinicId === clinic.id);
        return res;
    }

    toplamFilter(itemsSalary, currentClinic, clinicList) {
        const { profile } = this.props;
        if (itemsSalary.length > 0) {
            if (currentClinic !== 1)
                itemsSalary = itemsSalary.filter(it => it.clinicId === currentClinic);

            if (this._helper.isDoctor())
                itemsSalary = itemsSalary.filter(it => it.doctorId === profile.id);

            return {
                clinic: this.tr("report.total"),
                invoiceAmount: itemsSalary.reduce((acc, it) => { acc += it.invoiceAmount; return acc; }, 0),
                returnsSelectedPeriod: itemsSalary.reduce((acc, it) => { acc += it.returnsSelectedPeriod; return acc; }, 0),
                paid: itemsSalary.reduce((acc, it) => { acc += it.paid; return acc; }, 0),
                materials: itemsSalary.reduce((acc, it) => { acc += it.materials; return acc; }, 0),
                rentgen: itemsSalary.reduce((acc, it) => { acc += it.rentgen; return acc; }, 0),
                toPay: itemsSalary.reduce((acc, it) => { acc += it.toPay; return acc; }, 0),
            };
        }

        return {};
    }

    render() {
        const { itemsSalary, sort, tableSalaryMode, itemsSalaryDetails,
            securedInvoiceItems, itemsSalaryDetailsToplam, currentSecondText, selectedDoctor, itemsInvoiceToplam } = this.state;
        const { currentClinic, clinicList, profile } = this.props;

        const toplam = tableSalaryMode === "global" ? this.toplamFilter(itemsSalary, currentClinic, clinicList) :
            tableSalaryMode === "details" ? itemsSalaryDetailsToplam : itemsInvoiceToplam;
        let itemsSalaryFiltre = currentClinic === 1 ? itemsSalary : this.itemsSalaryFilter(itemsSalary, clinicList, currentClinic);
        if (this._helper.isDoctor())
            itemsSalaryFiltre = itemsSalary.filter(it => it.doctorId === profile.id);

        const tableMap = tableSalaryMode === "global" ? this.tableMap : tableSalaryMode === "details" ? this.tableMapDoctor : this.tableMapInvoice;
        const itemsForSalary = tableSalaryMode === "global" ? itemsSalaryFiltre : tableSalaryMode === "details" ? itemsSalaryDetails : securedInvoiceItems;

        return (<>
            <div className="flex between">
                <div className="flex gap16">
                    {tableSalaryMode !== "global" && <ButtonIcon name="arrowLeft" onClick={this.onReturnBackSalary.bind(this)} />}
                    <div>
                        <div className="text blockTitle">{this.getHeaderText(true)}</div>
                        <div className={`${tableSalaryMode === "global" ? "comment" : ""} text p2`}>{currentSecondText}</div>
                    </div>
                </div>
            </div>
            <div className="flex flex1">
                <Table
                    ref={el => this.refTableSalary = el}
                    map={tableMap}
                    items={itemsForSalary}
                    sort={sort}
                    onSortChange={this.onSortChange.bind(this)}
                    useToplam={toplam || {}}
                    selectedRow={tableSalaryMode === "global" ? selectedDoctor : -1}
                    rowProps={tableSalaryMode === "global" ? {
                        click: this.changeSalaryView.bind(this, "doctor")
                    } : {}}
                />
            </div>
        </>);
    }
}
